import React from 'react';
import './article.css';

// How to move the image from the Blog component to the Article component: 
// Inside our Blog we import all of our images.
// In order to change the image for each article, we need to pass the image as a prop.
// We get our imgUrl via imports.js in the Blog container. 
const Article = ({ imgUrl, date, title }) => (
  <div className="gpt3__blog-container_article">
    <div className="gpt3__blog-container_article-image">
      <img src={imgUrl} alt="blog" />
    </div>
    <div className="gpt3__blog-container_article-content">
      <div>
        <p>{date}</p>
        <h3>{title}</h3>
      </div>
      <p>Read Full Article</p>
    </div>
  </div>
);

export default Article;